import React, { useEffect, useState } from 'react'
import { getWpWonderKids } from '../../../../api/api_wp'
import { firestore } from '../../../../firebase'
import Loader from '../../../Loader/Loader'
import WonderKidListTemplate from './WonderKidListTemplate'

function AddWonderKidsFB() {

    const [postsFB, setPostsFB] = useState([])
    const [posts, setPosts] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const [show, setShow] = useState(false)

    useEffect(() => {

        try {
            const wonderKidsRef = firestore.collection("wonderkids")
            wonderKidsRef.onSnapshot(({docs}) => {
                const postsFB = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setPostsFB(postsFB)
            })
        } catch (error) {
            
        }

    }, [])

    useEffect(() => {
        async function getWonderKids() {
            setIsLoading(true)
            let allPlayers = []

            allPlayers = await getWpWonderKids(1, 100);

            if (allPlayers?.length === 100) {
                const dataPage2 = await getWpWonderKids(2, 100);
                allPlayers = allPlayers.concat(dataPage2);
            }
            setPosts(allPlayers)
            setIsLoading(false)
            
        }
        getWonderKids()
    }, [])

    function toggle() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    return (
        <div>
            <div className="card">
                <div className="card-header" onClick={toggle}>
                    <div>
                        FM Vidunderbarn
                        <span className="float-right">
                            <i className={`fas fa-chevron-${show ? "down" : "up"}`}></i>
                        </span>
                    </div>
                </div>
                
            </div>
            {show && (
                <div className="my-3">
                    {isLoading && <Loader />}
                    {posts?.map((post, index) => {
                        return <WonderKidListTemplate key={index} post={post} postsFB={postsFB} />
                    })}
                </div>
            )}

        </div>
    )
}
export default AddWonderKidsFB